import * as types from '@/store/mutationTypes';
import stbAPIGateway from '../../../services/stbAPIGateway';

export default {
  async initiateCrossTenantSession({ state, commit, rootGetters }) {
    try {
      if (state.crossTenantSessionHost) return;

      const axios = rootGetters['app/stbAxios'];
      const stbApi = stbAPIGateway(axios, process.env.API_URL);
      const response = await stbApi.postCrossTenantSession();
      if (response?.status === 'success') {
        commit(types.SET_CROSS_TENANT_SESSION_HOST, true);
      } else {
        commit(types.SET_CROSS_TENANT_SESSION_HOST, false);
      }
    } catch (error) {
      console.error('Error initiating cross-tenant session', error);
    }
  },

  async fetchCrossTenantSessionInfo({ commit, rootGetters }) {
    try {
      const axios = rootGetters['app/stbAxios'];
      const stbApi = stbAPIGateway(axios, process.env.API_URL);
      const response = await stbApi.getCrossTenantSessionInfo();
      commit(types.SET_CROSS_TENANT_SESSION, !!response?.crossTenantSession);
      return !!response?.crossTenantSession;
    } catch (error) {
      commit(types.SET_CROSS_TENANT_SESSION, false);
      return undefined;
    }
  }
};
